import { Component, inject, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormState } from '../../../apartment/contact-apartment/contact-apartment.component';
import {
    ApiService,
    NewsletterPayload,
} from '../../../../services/api.service';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { UmamiService } from '../../../../services/umami.service';

@Component({
    selector: 'app-newsletter-input-field',
    imports: [ReactiveFormsModule, TranslatePipe, NgClass],
    templateUrl: './newsletter-input-field.component.html',
})
export class NewsletterInputFieldComponent {
    colorMode = input<'white' | 'black'>('black');
    email = new FormControl('', [Validators.required, Validators.email]);
    formState = signal<FormState>(FormState.Idle);
    formStateEnum = FormState;
    umami = inject(UmamiService);
    private apiService = inject(ApiService);

    onSubmit() {
        this.formState.set(FormState.Submitting);
        this.apiService
            .createNewsletterEntry(this.createNewsletterPayload(this.email))
            .subscribe({
                error: (res) => {
                    if (
                        res.error.error.message ==
                        'This attribute must be unique'
                    ) {
                        this.formState.set(FormState.Success);
                        return;
                    }
                    this.formState.set(FormState.Error);
                },
                complete: () => {
                    this.formState.set(FormState.Success);
                },
            });
        this.umami.track('newsletter-email-submit', {
            email: this.email.value,
        });
    }

    private createNewsletterPayload(email: FormControl): NewsletterPayload {
        return {
            data: {
                email: email.value,
            },
        };
    }
}
